export default "./7542a1932c565d17944c6838da97ce94.svg";